import React from "react";
import * as PropTypes from "prop-types";

const CompPartitionHeader = (props) => {
    const {text, ...divProps} = props;

    return (
        <h2 className={`partition-header`} {...divProps}>
            {text}
        </h2>
    );
}
CompPartitionHeader.propTypes = {
    text: PropTypes.string,
};

export {CompPartitionHeader};